import { useState, useEffect } from 'react';
import { initializeAlarmData } from 'src/features/alarms/helper';
import { AlarmsService } from 'src/services/alarms';

type Props = {
  customerId?: string;
  siteId?: string;
  eventId?: string;
  isOpen: boolean;
};

export const useGetAlarmPopupInfo = ({ customerId, siteId, eventId, isOpen }: Props) => {
  const [alarmPopupInfo, setAlarmPopupInfo] = useState(initializeAlarmData());

  useEffect(() => {
    const getAlarmPopupInfo = async () => {
      if (!customerId || !siteId || !eventId || !isOpen) return;
      try {
        const response = await AlarmsService.getAlarmPopupInfo(customerId, siteId, eventId);
        setAlarmPopupInfo(response);
      } catch (error) {
        console.error(error);
        setAlarmPopupInfo(initializeAlarmData());
      }
    };
    getAlarmPopupInfo();
  }, [customerId, siteId, eventId, isOpen]);

  return { alarmPopupInfo };
};
